var $8e9c1a10ed1cc18a$exports = {};
$8e9c1a10ed1cc18a$exports = {
    "invalidSelection": (args, formatter)=>`Se\xe7ilen ${formatter.plural(args.selectedCount, {
            one: `tarih`,
            other: `tarihler`
        })} m\xfcsait de\u{11F}il.`
};


export {$8e9c1a10ed1cc18a$exports as default};
//# sourceMappingURL=tr-TR.module.js.map
